import React from 'react'
import '../stylesheets/Submit.css';
import {BrowserView, MobileView} from 'react-device-detect';

export const Submit = () => {
  return (
     <div className= "body">
            <h2 className="subhead" id="first">Submit</h2>
            <div>
            <BrowserView>
              <h2>Submit</h2>
            </BrowserView>
            <MobileView>
              <h2>Submit</h2>
            </MobileView>
            </div>
      </div>
  )
}
